import DOMPurify from "dompurify";

/**
 * Instancia propia de DOMPurify, para que sus hooks no afecten a los demás saneados de la web (barra de estado,
 * competiciones...).
 */
const contractPurifier = DOMPurify(window);

contractPurifier.addHook("afterSanitizeAttributes", (node) =>
{
    // Los enlaces que abren otra pestaña no deben poder controlar esta (window.opener)
    if(node.hasAttribute("target"))
    {
        node.setAttribute("rel", "noopener noreferrer");
    }
});

/**
 * Sanea el HTML de un contrato antes de pintarlo con dangerouslySetInnerHTML.
 *
 * Los contratos son plantillas de base de datos que redactan los administradores (tablas, estilos inline, bloques
 * <style>, imágenes y enlaces), así que se usa el perfil por defecto de DOMPurify en lugar de una lista cerrada de
 * etiquetas: se conserva el formato y se quita todo lo que pueda ejecutar código (<script>, manejadores on*,
 * href "javascript:"...). Las plantillas llevan datos de los intervinientes y en planes con varios titulares lo que
 * escribe uno se pinta en la sesión de otro (auditoría de seguridad WEB-09).
 *
 * FORCE_BODY evita que un <style> al principio de la plantilla se pierda (el parser lo mandaría al <head>) y
 * "target" se admite para que los enlaces sigan abriéndose en otra pestaña.
 */
export function sanitizeContractHtml(html?: string | null): string
{
    if(!html)
    {
        return "";
    }

    return contractPurifier.sanitize(html, { FORCE_BODY: true, ADD_ATTR: ["target"] });
}
